import {
  useQuery,
  UseQueryOptions,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { ID, IdProvider, Timestamp, unwrap } from '../common/apiCommons';
import axios from 'axios';

export const AUTOENDWARNING = 'AUTOENDWARNING';
export const AUTOENDWARNINGCOUNT = 'AUTOENDWARNINGCOUNT';

export interface AutoEndWarning {
  type: string;
  id: ID;
  seen_by_admin: boolean;
  resolved: boolean;
  employee: ID;
  date: ID;
  pause_duration: number;
}

type AutoWarningQueryParams = IdProvider & { start: Timestamp; end: Timestamp };
const queries = {
  async getEmployeeWarnings(request: AutoWarningQueryParams) {
    if (!request.id) {
      return null;
    }
    const res = await axios.get<AutoEndWarning[]>(
      `/warnings/auto_end/?employee=${request.id}&start=${request.start}&end=${request.end}`,
    );
    return unwrap(res);
  },
};

const mutations = {
  async seenWarning(warning: AutoEndWarning) {
    const res = await axios.post<void>(
      `/warnings/auto_end/seen/${warning.id}/`,
    );
    return unwrap(res);
  },
};

const hooks = {
  useEmployeeWarnings(
    request: AutoWarningQueryParams,
    options?: UseQueryOptions<AutoEndWarning[] | null>,
  ) {
    return useQuery({
      queryKey: [AUTOENDWARNING, request.id, request.start, request.end],
      queryFn: () => queries.getEmployeeWarnings(request),
      enabled: !!request && !!request.start && !!request.end && !!request.id,
      ...(options ?? {}),
    });
  },
  useAdminHasSeenWarning() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: mutations.seenWarning,
      onSuccess: async (_data, params) => {
        await queryClient.invalidateQueries([AUTOENDWARNING, params.employee]);
      },
    });
  },
};

const AutoEndWarningApi = { queries, mutations, hooks };

export default AutoEndWarningApi;
